import React, { Component } from 'react'
import { Box, Button, Input, KeyValueRow, Modal, Switch } from 'components'
import { T, __ } from 'translations/i18n'
import { Spacer } from 'components/Various'
import AppStore from 'AppStore'
import { refresh } from 'shared/router'
import { sleep, __isDev } from 'shared/utils'

interface Props {
  onClose: () => void
  visible: boolean
}

interface State {
  admin: boolean
  endpoint: string
}

export default class SettingsModal extends Component<Props, State> {
  languages = [
    { label: 'English', value: 'en' },
    { label: 'Italiano', value: 'it' },
  ]
  state: State = { admin: false, endpoint: '' }

  handleChange = (item: any) => {
    AppStore.changeLanguage(item.value)

    sleep(100).then(() => refresh())
  }

  activateAdmin = () => {
    if (prompt('Insert admin password', '') !== '7733') return
    this.setState({ admin: true })
  }

  async componentDidMount() {
    this.setState({ endpoint: await AppStore.getEndpoint() })
  }

  onEmulationClick = async (checked: boolean) => {
    await AppStore.enableEmulation(checked)
    this.forceUpdate()
  }

  render() {
    const { onClose, visible } = this.props
    const { admin, endpoint } = this.state
    return (
      <Modal size="lg" onClose={onClose} visible={visible}>
        <Box vcenter row mb={30}>
          <Modal.Title>{__(T.titles.settings)}</Modal.Title>
          <Button size="small" title="ADMIN MODE" onClick={this.activateAdmin} variant="secondary" />
        </Box>
        {!admin && <KeyValueRow variant="grey" label="Backend" value={endpoint} />}
        {admin && <Input label="Backend" onEnter={AppStore.setEndpoint} defaultValue={endpoint} />}

        <Spacer />

        <KeyValueRow
          variant="grey"
          label={__(T.misc.language)}
          value={this.languages.find((language) => language.value === AppStore.language)?.label}
          optionModal={{
            onSelect: (item) => this.handleChange(item[0]),
            field: 'label',
            options: this.languages ?? [],
            title: __(T.titles.select_language),
            selected: [{ label: this.languages.find((language) => language.value === AppStore.language)?.label }],
          }}
        />

        {(AppStore.loggedUser?.admin || __isDev || admin) && (
          <>
            <Spacer />
            <Spacer />
            <Switch
              onChange={this.onEmulationClick}
              check={AppStore.emulation}
              name="emulation"
              label={__(T.misc.enable_workstation_emulation)}
            />
          </>
        )}
      </Modal>
    )
  }
}
